export const getDateStr = (str: string | Date | null):string => {
    return str ? new Date(str).toDateString().split(" ").slice(1).join(" ") : "";
};

export const getDateTimeStr = (str: string | Date | null):string => {
    return str ?  new Date(str).toLocaleString("en-US", {
        day: "numeric", month: "short", year: "numeric",
        hour: "numeric", minute: "numeric", hour12: false
    }) : "";
};
